import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const typeform = defineConnector({
  identifier: "typeform",
  name: "Typeform",
  tagLine: "Online form and survey builder",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.typeform\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Typeform API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Typeform Account Settings](https://admin.typeform.com/account#/section/tokens) and generate a **Personal Access Token**.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Personal Access Token",
          placeholder: "tfp_...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.typeform.com/me",
  },
});
